import { Link } from 'react-router-dom';

interface ArticleCardProps {
  slug: string;
  title: string;
  category: string;
  categorySlug: string;
  excerpt: string;
  coverImage: string;
  readTime: number;
  date: string;
  tags: string[];
}

const categoryNames: Record<string, string> = {
  'xinggan-chuanda': '性感穿搭技巧',
  'qizhi-tisheng': '气质提升方法',
  'xinggan-zhuangrong': '性感妆容教程',
  'zixin-fengge': '自信女性风格',
  'shishang-zaoxing': '时尚性感造型',
};

export default function ArticleCard({
  slug,
  title,
  category,
  categorySlug,
  excerpt,
  coverImage,
  readTime,
  date,
  tags,
}: ArticleCardProps) {
  return (
    <article className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-background-300 transition-all duration-300">
      <Link to={`/article/${slug}`} className="block">
        <div className="relative w-full h-48 md:h-52 overflow-hidden">
          <img
            src={coverImage}
            alt={title}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          />
          <div className="absolute top-3 left-3">
            <Link
              to={`/category/${categorySlug}`}
              className="inline-block px-2.5 py-1 text-xs font-medium bg-background-50/90 text-foreground-700 rounded-full hover:bg-primary-100 hover:text-primary-700 transition-colors whitespace-nowrap"
              onClick={(e) => e.stopPropagation()}
            >
              {categoryNames[category] || category}
            </Link>
          </div>
        </div>
      </Link>
      <div className="p-4 md:p-5">
        <Link to={`/article/${slug}`}>
          <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
            {title}
          </h3>
        </Link>
        <p className="text-sm text-foreground-600 leading-relaxed mb-3 line-clamp-2">
          {excerpt}
        </p>
        <div className="flex items-center justify-between text-xs text-foreground-500">
          <div className="flex items-center gap-3">
            <span className="flex items-center gap-1">
              <i className="ri-time-line" />
              {readTime} 分钟阅读
            </span>
            <span>{date}</span>
          </div>
        </div>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="px-2 py-0.5 text-xs bg-secondary-100 text-secondary-700 rounded-full whitespace-nowrap"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </article>
  );
}